import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Payment} from "../payment";
import {PaymentService} from "../payment-service.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
export class PaymentListComponent implements OnInit {

  payments: Payment[];
  id: string;
  customerId: string;
  invoiceId: string;
  action: string;
  myError: string;

  constructor(private paymentService: PaymentService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.myError = "";
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.invoiceId = this.activatedRoute.snapshot.params['invoiceId'];
    this.action = this.activatedRoute.snapshot.params['action'];

    if (this.action.localeCompare("show") == 0) {
      if (this.invoiceId.localeCompare("0") == 0) {
        this.paymentService.findAll().subscribe(data => this.payments = data, error => this.myError= "Payments not found");
      } else {
        this.paymentService.findAllByInvoiceId(this.invoiceId).subscribe(data => this.payments = data, error => this.myError= "Payments not found");
      }
    }
    if (this.action.localeCompare("delete") == 0) {
      this.paymentService.delete(this.id).subscribe(result => this.gotoPaymentList(), error => this.myError= "Payment deletion not confirmed");
    }
  }

  gotoPaymentList() {
    this.router.navigate(['/payments/show/' + this.customerId + "/" + this.invoiceId + "/0"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-list/payment-list.component.ts